import { SET_ACTIVE_SERVER } from './constants'

// Initial state of the store
const initialState = ''
// Sample state:
// const initialState = 'tq'

const activeServer = (state = initialState, action) => {
    switch (action.type) {
        // Set the active server
        case SET_ACTIVE_SERVER: {
            return action.payload
        }

        // Default state
        default:
            return state
    }
}

export default activeServer



// WEBPACK FOOTER //
// ./src/features/Backend/data/activeServer/reducer.js